module.exports = __webpack_public_path__ + "static/twitter_generic-70ba2e1f33919bc8714fa62a309522b5.png";